<template>
  <el-form
    ref="form"
    label-width="100px"
    label-position="right"
    :inline="true"
    size="mini"
    class="search-form"
  >
    <el-row v-if="!isEdit">
      <el-col>
        <el-button type="primary" size="mini" plain @click="handlePrevious">
          <i class="el-icon-arrow-left"></i>PREV
        </el-button>
        <el-button type="primary" size="mini" plain @click="handleNext">
          NEXT
          <i class="el-icon-arrow-right"></i>
        </el-button>
        <btn-clone v-if="hasBtnClone"></btn-clone>
      </el-col>
    </el-row>
    <el-divider v-if="!isEdit"></el-divider>

    <el-row>
      <el-col v-for="c in config" :key="c.hash" :span="c.span" :class="c.labelClass||''">
        <ElementCreator :config="c" />
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import ElementCreator from './ElementCreator'
import BtnClone from './BtnClone'
import { routeTR, routeAJ } from '../router'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'OrderInputs',
  components: {
    ElementCreator,
    BtnClone
  },
  props: {
    config: {
      type: Array,
      required: true
    },
    isEdit: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    hasBtnClone () {
      const routeName = this.$route.params.routeName
      return routeName !== routeTR && routeName !== routeAJ
    },

    ...mapGetters({
      routeNameGetter: 'getRouteNameFromOrderType'
    })
  },
  methods: {
    ...mapActions({
      nextId: 'edit/nextId'
    }),
    async handlePrevious () {
      const data = await this.nextId('prev')
      if (data.id > 0) {
        this.$router.push({
          name: 'OrderDetail',
          params: { routeName: this.routeNameGetter(data.type), id: data.id }
        })
      } else {
        this.noMoreData()
      }
    },
    async handleNext () {
      const data = await this.nextId('next')
      if (data.id > 0) {
        this.$router.push({
          name: 'OrderDetail',
          params: { routeName: this.routeNameGetter(data.type), id: data.id }
        })
      } else {
        this.noMoreData()
      }
    },
    noMoreData () {
      this.$message({
        showClose: true,
        duration: 5000,
        type: 'warning',
        dangerouslyUseHTMLString: true,
        message: 'No more data to load'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.btns-row {
  justify-content: center;
}
.el-divider {
  margin: 6px 0;
  background-color: #e5e5f14b;
}
</style>
